/**
 * Utilitário para gerenciar o modo administrador
 * Controla a visibilidade e disponibilidade de funcionalidades de exclusão
 */

const ADMIN_MODE_KEY = 'adminModeActive';

/**
 * Verifica se o modo administrador está ativo
 * Retorna true APENAS se o usuário for admin (user_level_id === 1) E o modo estiver ativo
 * @returns {boolean}
 */
export function isAdminModeActive() {
  try {
    const user = JSON.parse(localStorage.getItem('user'));

    // Verifica se o usuário é administrador (user_level_id === 1)
    if (!user || Number(user.user_level_id) !== 1) {
      return false;
    }

    // Verifica se o modo administrador está ativo
    const adminMode = getAdminMode();
    return adminMode === true;
  } catch (error) {
    console.error('Erro ao verificar modo administrador:', error);
    return false;
  }
}

/**
 * Define o estado do modo administrador
 * @param {boolean} active - true para ativar, false para desativar
 */
export function setAdminMode(active) {
  try {
    localStorage.setItem(ADMIN_MODE_KEY, JSON.stringify(active));
  } catch (error) {
    console.error('Erro ao salvar modo administrador:', error);
  }
}

/**
 * Obtém o estado atual do modo administrador do localStorage
 * @returns {boolean} - false por padrão
 */
export function getAdminMode() {
  try {
    const value = localStorage.getItem(ADMIN_MODE_KEY);
    if (value === null) {
      return false; // Padrão: modo administrador inativo
    }
    return JSON.parse(value);
  } catch (error) {
    console.error('Erro ao ler modo administrador:', error);
    return false;
  }
}

/**
 * Verifica se o usuário atual é administrador (user_level_id === 1)
 * @returns {boolean}
 */
export function isUserAdmin() {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    return Boolean(user && Number(user.user_level_id) === 1);
  } catch (error) {
    console.error('Erro ao verificar status de admin:', error);
    return false;
  }
}
